export function getFieldLabelId(fieldId) {
  return `${fieldId}-label`;
}

export function getFieldHintId(fieldId) {
  return `${fieldId}-hint`;
}

export function getFieldErrorId(fieldId) {
  return `${fieldId}-error`;
}

export function getFieldAriaProps(fieldId, error, hasHint = false) {
  const describedByIds = [hasHint ? getFieldHintId(fieldId) : null, error ? getFieldErrorId(fieldId) : null].filter(Boolean);
  return {
    'aria-invalid': error ? true : undefined,
    'aria-describedby': describedByIds.length > 0 ? describedByIds.join(' ') : undefined,
  };
}

export function pickTouchedErrors(errors, touchedFields) {
  return Object.fromEntries(Object.entries(errors).map(([fieldName, error]) => [fieldName, touchedFields[fieldName] ? error : null]));
}

export function findFirstInvalidField(errors, fieldOrder) {
  return fieldOrder.find((fieldName) => errors[fieldName]) ?? null;
}